<template lang="">
	<div class="responsive-note mt-8" style="height: 100vh">		
		<v-card
			width="1246px"
			height="137px"
			class="pa-8" 
		>
			<h4>Canal de envio</h4>
			
			<v-radio-group class="mt-8" row v-model="channel">
        <v-radio class="mr-4" type="radio" :value="EMAIL" /><label class="mr-200">E-mail</label>
        <v-radio class="mr-4" type="radio" :value="SMS" /><label class="mr-200">Mensagem (SMS)</label>
        <v-radio class="mr-4" type="radio" :value="PUSHAPP" /><label class="mr-200">Push App</label>
			</v-radio-group>
		</v-card>

		<v-card
			class="mt-8 pa-8 mt-8"
		>
			<div class="d-flex flex-row">
				<div class="d-flex flex-column mr-8" >
					<label class="font-weight-black">Copy</label>
					<v-select
						:options="copiesList"
						v-model="item.copy.copy_id"
						@change="updateCommunicationCopy"
						dense
						outlined
						rounded
						class="input-fields mt-3 pt-2"
					></v-select>
				</div>
				<div class="d-flex flex-column">
					<label class="font-weight-black">ID Promo</label>
					<input
						v-model="item.communication_id_shot"
						type="text"
						placeholder="ID Promo"
						class="input-fields pl-2 mt-3"
					>
				</div>
			</div>
			<!-- E-mail -->
			<!-- Mesnagem -->
			<div
				class="d-flex flex-column mt-7"
				style="width: 1150px"
				v-if="channel === 'SMS' || channel === 'PUSHAPP'"	
			>
				<label class="font-weight-black">Call to Action / Link</label>
				<input
					v-model="item.communication_call_to_link"
					type="text"
					placeholder="Call to Action / Link"
					class="b pl-2 mt-3 h-48 input-field-idpromo"
				>
			</div>
			<div class="mt-7 d-flex" :class="channel === 'SMS' ? '' : 'flex-column'">
				<div class="d-flex flex-column mr-8">
					<label class="font-weight-black">Conteúdo do e-mail<span v-if="channel != 'EMAIL'" class="textAreaLength"> {{textAreaLength}}/{{channel === 'SMS' ? 127 : 200}}</span></label>
					<textarea
						outlined
						height="192px"
						v-model="item.communication_text"
						class="rounded mt-3 b"
						:class="channel === 'SMS' ? 'textarea-sms' : 'textarea'"
						rows="8"
						:maxlength="maxLengthTextArea"
						placeholder="Texto da mensagem"
					></textarea>
				</div>
				<div class="pl-2" v-if="channel === 'SMS'">
					<label class="font-weight-black">Visualização (sem acentuação para SMS)</label>
					<div
						class="b mt-3"
						:class="[
							channel === 'SMS' ? 'textarea-sms' : 'textarea',
							item.communication_text === 'Texto da mensagem' || item.communication_text === '' ? 'text-background' : ''
						]"
					>{{smsMessage}}</div>
				</div>
			</div>
			<!-- toogle -->
			<div class="mt-7 d-flex justify-space-between">
				<span class="d-flex flex-row align-center">
					<span class="mr-3">Status</span>
					<v-switch
						v-model="item.communication_is_active"
						color="var(--blue)"
						inset
					></v-switch>
				</span>
				<span class="d-flex flex-row align-center">
					<span class="mr-3">Fórmula de Lançamento</span>
					<v-switch
						v-model="item.communication_is_formula_lancamento"
						color="var(--blue)"
						inset
					></v-switch>
				</span>
				<span class="d-flex flex-row align-center">
					<span class="mr-3">Aprovado</span>
					<v-switch
						v-model="item.communication_approval"
						color="var(--blue)"
						inset
					></v-switch>
				</span>
				<span class="d-flex flex-row align-center">
					<span class="mr-3">Relacionamento</span>
					<v-switch
						v-model="item.communication_relationship"
						color="var(--blue)"
						inset
						class="switch"
					></v-switch>
				</span>
			</div>
		</v-card>

		<v-card class="d-flex flex-row mt-8 justify-space-between align-center pa-7" height="72px" color="var(--grey-day-070)">
			<span class="white--text">Aqui sua comunicação será salva.</span>
			<v-btn
				height="48px"
				width="130px"
				class="px-3 py-3"
				@click="submitEmail"
				:disabled="enable.buttonSubmit || loading"
				:color="enable.buttonSubmit ? '' : 'var(--white)'"
			>
				<img src="../../../../static/images/save.svg" />
				<span class="pl-3 py-3" style="fontFamily: var(--dm-sans-regular);">Salvar</span>
			</v-btn>
		</v-card>

		<v-snackbar 
      v-model="toaster.visible"
      :timeout="3000"
			:color="toaster.color"
      absolute
			top
    >
      {{ toaster.message }}
    </v-snackbar>
	</div>
</template>
<script>
// Components

// Libs
import { mapMutations, mapActions, mapState } from 'vuex'
import StringHelper from '@/helpers/string'

// token
import VueCookies from 'vue-cookies'

export default {
	components: {
	},
	data () {
		return {
			radioGroup: 1,
      radios: 'radio-1',
			copy: '',
			IDPromo: '',
			textmessage: '',
			smsMessage: '',
			// radio
			channel: 'EMAIL',
			EMAIL: 'EMAIL',
			SMS: 'SMS',
			PUSHAPP: 'PUSHAPP',
			enable: {
        buttonSubmit: true
      },
			toaster: {
				visible: false,
				color: null,
				message: ''
			}
		}
	},
	computed: {
		...mapState('Copy', {
      copyItems: 'items'
    }),
		...mapState('Communication', {
      item: 'communicationToEdit',
      loading: 'loading',
			newCampaign: 'newCampaign'
    }),
		copiesList () {
			const copies = this.copyItems.data ? this.copyItems.data : []
      return copies.map(copy => ({
        value: copy.copy_id,
        label: copy.copy_name
      }))
    },
		textAreaLength () {
      return this.item.communication_text.length
    },
		maxLengthTextArea () {
			if (this.channel === 'SMS') {
				return 127
			} else if (this.channel === 'PUSHAPP') {
				return 200
			} else {
				return 200000
			}
		},
		textSMSMessage () {
			const sms = this.item.communication_text
			return sms
		},
	},
	methods: {
    ...mapActions('Copy', [
      'getCopies'
    ]),
    ...mapActions('Communication', [
      'postCommunication'
    ]),
    ...mapMutations('Copy', {
      setStatusFilter: 'SET_STATUS_FILTER',
      setProductFilter: 'SET_PRODUCT_FILTER',
      setCopyPageSize: 'SET_PAGE_SIZE'
    }),
    ...mapMutations('Communication', {
      setLoading: 'SET_LOADING',
      unsetCommunicationToEdit: 'UNSET_COMMUNICATION_TO_EDIT',
			setNewTab: 'SET_TAB_NEW_COMMUNICATION'
    }),
    ...mapMutations('Shared', {
      setToaster: 'SET_TOASTER'
    }),
		updateCommunicationCopy(option) {
      this.item.copy.copy_id = option
    },
		async submitEmail () {
			this.setLoading(true)
			const token = VueCookies.get('jwt-login')
      try {
				if (this.channel === 'EMAIL') {
					const response = await this.postCommunication([
						{
							communication_text: this.item.communication_text,
							copy: {
								copy_id: this.item.copy.copy_id.value,
								copy_name: this.item.copy.copy_name.label,
								copy_is_active: this.item.copy.copy_is_active,
								copy_updated_at: this.item.copy.copy_updated_at,
								product: {
									product_id: this.item.copy.product.product_id,
									product_name: this.item.copy.product.product_name,
									product_owner_name: this.item.copy.product.product_owner_name,
									product_is_active: this.item.copy.product.product_is_active,
									product_updated_at: this.item.copy.product.product_updated_at,
								}
							},
							communication_id: this.item.communication_id,
							communication_id_shot: this.item.communication_id_shot,
							communication_comment_shot: this.item.communication_comment_shot,
							communication_type: this.channel,
							communication_is_active: this.item.communication_is_active,
							communication_is_formula_lancamento: this.item.communication_is_formula_lancamento,
							communication_approval: this.item.communication_approval,
							communication_relationship: this.item.communication_relationship,
							communication_updated_at: this.item.communication_updated_at 
						},
						token
					])
					if (response.status >= 400) {
						throw new Error(response.data.message)
					} else {
						this.toaster.visible = true
						this.toaster.color = 'var(--green)'
						this.toaster.message = 'Concluido'
						this.unsetCommunicationToEdit()
						this.setLoading(false)
						this.setNewTab(true)
						window.scrollTo(0, 0)
					}
				} else if (this.channel === 'SMS' || this.channel === 'PUSHAPP') {
					const response = await this.postCommunication([
						{
							communication_text: this.item.communication_text,
							communication_text_normalized: this.smsMessage,
							copy: {
								copy_id: this.item.copy.copy_id.value
							},
							communication_id_shot: this.item.communication_id_shot,
							communication_comment_shot: this.item.communication_comment_shot,
							communication_call_to_link: this.item.communication_call_to_link,
							communication_type: this.channel,
							communication_is_active: this.item.communication_is_active,
							communication_is_formula_lancamento: this.item.communication_is_formula_lancamento,
							communication_approval: this.item.communication_approval,
							communication_relationship: this.item.communication_relationship
					},
					token
					])
					if (response.status >= 400) {
						throw new Error(response.data.message)
					} else {
						this.toaster.visible = true
						this.toaster.color = 'var(--green)'
						this.toaster.message = 'Comunicação criada com sucesso'
						this.unsetCommunicationToEdit()
						this.setLoading(false)
						window.scrollTo(0, 0)
					}
				}
      } catch (e) {
				this.toaster.visible = true
				this.toaster.color = 'var(--red)'
				this.toaster.message = e.message
        // this.toaster(e.message, 'danger', true)
      }
    },
		enableSubmit() {
      if (this.checkFields()) {
        this.enable.buttonSubmit = false;
      } else {
        this.enable.buttonSubmit = true;
      }
    },
		checkFields() {
      if (
        (this.item.copy.copy_id !== null && this.item.copy.copy_id !== '') &&
        (this.item.communication_id_shot !== null && this.item.communication_id_shot !== '') &&
        (this.item.communication_text !== null && this.item.communication_text !== '')
      ) {
        return true;
      } else {
        return false;
      }
    }
	},
	watch: {
		'item.communication_text' () {
      this.smsMessage = StringHelper.removeSpecialCharacters(this.item.communication_text.split('–').join('-'))
      this.messageSize = this.item.communication_text.length
      this.enableSubmit()
    },
		'item.copy.copy_id' () {
      this.enableSubmit()
    },
    'item.communication_id_shot' () {
      this.enableSubmit()
    },
	}
}
</script>
<style lang="" scoped>
h4 {
	font-size: 20px;
}

.mr-200 {
	margin-right: 200px;
}

.b {
	border: 2px solid var(--grey-day-030);
}

.h-48 {
	height: 48px;
}

v-btn {
	width: 137px !important;
}

.textarea-sms {
	width: 560px;
	height: 192px
}

.textarea {
	width: 1150px;
}

.text-background {
	background: var(--grey-day-030);
	color: var(--grey-day-070)
}

.input-fields {
	background: var(--white);
	border: 2px solid var(--grey-day-030);
	border-radius: 4px;
	width: 560px;
	max-width: 560px;
	height: 48px;
}

/* input { */
	/* outline: none;
	border: none;
	background: transparent; */
	/* max-width: 560px; */
	/* font-size: 1rem;
	font-family: var(--dm-sans-regular);
	color: var(--grey); */
/* } */

.textAreaLength {
	font-size: 14.22px;
	color: var(--grey);
	font-weight: 100
}

.responsive-note {
	width: 1224px
}
@media screen and (max-width: 1377px) {
	.responsive-note {
		width: 819px
	}

	.input-fields, .textarea-sms {
		width: 362px;
	}

	.textarea, .input-field-idpromo {
		width: 755px
	}

	.mr-200 {
		margin-right: 100px
	}
}

</style>


// WEBPACK FOOTER //
// src/components/Contents/AutomaticsTriggers/NewCommunication.vue